import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var RegionsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default RegionsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Regions/RegionsReduxProps.ts
// module id = 427
// module chunks = 0